import {
    DATA_SUMMARY_MODAL_I18N_KEYS
  } from '../../../../../features/topics/components/constants/i18n/DataSummaryModali18nConstants';
  
  export const DATA_SUMMARY_MODAL_I18N_EN = {
    [DATA_SUMMARY_MODAL_I18N_KEYS.modal_title]:                     "Data Summary",
    [DATA_SUMMARY_MODAL_I18N_KEYS.select_another_file_button_text]: "Select another file",
    [DATA_SUMMARY_MODAL_I18N_KEYS.confirm_file_button_text]:        "Confirm file"
  };


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/data_summary_modal.i18n.en.js